"use strict";

exports.__esModule = true;
exports.default = void 0;

var cloneSvg = function cloneSvg(sourceSvg) {
  return sourceSvg.cloneNode(true);
};

var _default = cloneSvg;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tanem/svg-injector/lib/clone-svg.js
// module id = 65
// module chunks = 0